import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import FetchApi from '../../customhooks/functionFetchApi';
import Statusall from '../../journal/components/componentallstatus/statusall';
import Flowuserapprove from '../../journal/components/componentallstatus/flowuserapprove';
import ViewJournaldetail from '../../journal/components/componentallistallpprovebyuser/viewJournaldetail';
import PopUpCheckList from '../../journal/components/componentjournallistrecieved/popUpCheckList';
import Swal from 'sweetalert2';

const Quaritylistjournal = () => {
  const aId = sessionStorage.getItem('aId');
  const departId=sessionStorage.getItem('DepartId');
  const [journals, setJournals] = useState([]);

  useEffect(() => {
    const FetchApis = new FetchApi();
    const getlistjournal = async () => {
      try {
        const res = await FetchApis.FethcGet(`/quarity/gettdstCheckQuarityByApproved/${aId}`);
        if (res?.status === 200) {
          console.log('Fetch journal list:', res.data.data);
          const items = Array.isArray(res.data.data) ? res.data.data : [];
          setJournals(
            items.map((item, index) => ({
              ...item,
              id: item.id || item.tdscode || index,
            }))
          );
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    };

    getlistjournal();
  }, [aId]);

  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedJournal, setSelectedJournal] = useState(null);

  const openActionPopup = (row) => {
    setSelectedJournal(row);
    setPopupOpen(true);
  };

  const [checkedPass, setCheckedPass] = useState(false);
  const [checkedFail, setCheckedFail] = useState(false);
  const [remarkText, setRemarkText] = useState('');

  const closeActionPopup = () => {
    setSelectedJournal(null);
    setCheckedPass(false);
    setCheckedFail(false);
    setRemarkText('');
    setPopupOpen(false);
  };

  const columns = [
    {
      name: 'ลำดับ',
      selector: (row, index) => index + 1,
      minWidth: '60px',
      maxWidth: '80px',
      sortable: true,
    },
    {
      name: 'TDScode',
      selector: (row) => row.tdscode || '-',
      sortable: true,
      wrap: true,
      minWidth: '120px',
      grow: 1,
    },
    {
      name: 'Rv.',
      selector: (row) => row.revision || '-',
      sortable: true,
      wrap: true,
      minWidth: '50px',
    },
    {
      name: 'createdate',
      selector: (row) => row.createdate || '-',
      sortable: true,
      wrap: true,
      minWidth: '120px',
    },
    {
      name: 'ประเภทงาน',
      selector: (row) => {
        const type = row.fname || '-';
        const group = row.productgrouptype || '-';
        const creator = row.createbyName || '-';
        return (
          <div style={{ display: 'grid', rowGap: '4px' }}>
            <span style={{ fontWeight: 600, color: '#1f4e8a' }}>{type}</span>
            <span style={{ fontSize: '0.85rem', color: '#555' }}>กลุ่มสินค้า: {group}</span>
            <span style={{ fontSize: '0.85rem', color: '#555' }}>ผู้สร้าง: {creator}</span>
          </div>
        );
      },
      sortable: true,
      wrap: true,
      minWidth: '260px',
      grow: 2,
    },
    {
      name: 'status flow',
      selector: (row) => <Statusall id={row.journalId} statusNow={row.stateflow} stateSuccesfull={row.stateSuccesfull} />,
      wrap: true,
      // grow: 2,
      minWidth: '150px',
    },
    {
      name: 'ประวัติการอนุมัติ',
      selector: (row) => <Flowuserapprove id={row.journalId}
        stateflow={row.stateflow}
        departments={row.departments}
        accountapprove={row.accountapprove} />,
      wrap: true,
      grow: 3,
    },
    {
      name: 'สถานะตรวจ',
      cell: (row) => (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <PopUpCheckList tdsCode={row.tdscode} />
        </div>
      ),
      width: '155px',
      center: true,
      ignoreRowClick: true,
      allowOverflow: true,
    },
    {
      name: 'Action',
      cell: (row) => (
        <div style={{ display: 'flex', gap: '4px', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
          <ViewJournaldetail jourId={row.journalId} codeId={row.tdscode} revise={row.revision} />
          <button
            type="button"
            onClick={() => openActionPopup(row)}
            style={{
              padding: '3px 8px',
              borderRadius: '4px',
              border: '1px solid #1976d2',
              background: '#1976d2',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '0.75rem',
              whiteSpace: 'nowrap',
            }}
          >
            จัดการ
          </button>
        </div>
      ),
      width: '110px',
      center: true,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const updateJournalStatus = (journal) => {
    console.log('Updating journal status for:', journal);
    const FetchApis = new FetchApi();
    if (checkedPass) {
      if (!remarkText || !remarkText.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'กรุณาใส่หมายเหตุ',
          text: 'โปรดกรอกหมายเหตุ (Remark) ก่อนยืนยันการอนุมัติ'
        });
        return;
      }
      Swal.fire({
        title: 'ยืนยันการอนุมัติ',
        text: `คุณต้องการอนุมัติรายการ ${journal.tdscode || '-'} หรือไม่?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'ใช่, อนุมัติ',
        cancelButtonText: 'ไม่, ยกเลิก',
      }).then((result) => {
        if (result.isConfirmed) {

        //  alert(`ยืนยันรายการ ${journal.tdscode || '-'} ผ่านการตรวจสอบแล้ว`);

          FetchApis.FethcUpdate(`/quarity/UpdateQualityCheckStatus`, { tdscode: journal.tdscode, statusQuarily: '1', departmentId: departId, remark: remarkText }).then((res) => {
            if (res?.status === 200) {
              // window.location.reload();
              CeateNote({ typestatus: '1', detailnote: remarkText, datestamp: '', createby: aId, tdscode: journal.tdscode, departmentId: departId, journalId: journal.journalId });
            }
          }).catch((error) => {
            console.error('Update error:', error);
          });

        }
      });
    } else if (checkedFail) {
      if (!remarkText || !remarkText.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'กรุณาใส่หมายเหตุ',
          text: 'โปรดกรอกหมายเหตุ (Remark) ก่อนยืนยันการไม่ผ่าน'
        });
        return;
      }
      Swal.fire({
        title: 'ยืนยันไม่ผ่าน',
        text: `คุณต้องการอัปเดตรายการ ${journal.tdscode || '-'} เป็น ไม่ผ่าน หรือไม่?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ใช่, ไม่ผ่าน',
        cancelButtonText: 'ไม่, ยกเลิก',
      }).then((result) => {
        if (result.isConfirmed) {

          // alert(`ยืนยันรายการ ${journal.tdscode || '-'} ไม่ผ่านการตรวจสอบแล้ว`);

          FetchApis.FethcUpdate(`/quarity/UpdateQualityCheckStatus`, { tdscode: journal.tdscode, statusQuarily: '0', departmentId: departId, remark: remarkText }).then((res) => {
            if (res?.status === 200) {
              // window.location.reload();
              CeateNote({ typestatus: '0', detailnote: remarkText, datestamp: new Date(), createby: aId, tdscode: journal.tdscode, departmentId: departId, journalId: journal.journalId });
            }
          }).catch((error) => {
            console.error('Update error:', error);
          });

        }
      });
    } else {
      Swal.fire({
        icon: 'info',
        title: 'กรุณาเลือกสถานะ',
        text: 'โปรดเลือก "ผ่านจัด" หรือ "ไม่ผ่าน" ก่อนยืนยัน'
      });
    }
  };

  const CeateNote = (journal) => {
    const FetchApis = new FetchApi();
    
    FetchApis.FethcPost(`/quarity/CreateCheckQuarityNote`, { typestatus: journal.typestatus, detailnote: journal.detailnote, datestamp: '', createby: aId, tdscode: journal.tdscode, departmentId: departId, journalId: journal.journalId }).then((res) => {
      if (res?.status === 200) {
        console.log('Create note success:', res.data);
        window.location.reload();
      }
    }).catch((error) => {
      console.error('Create note error:', error);
    });
  }

  return (
    <div style={{ padding: '16px' }}>
      <h2>รายการตรวจคุณภาพ (Quality List)</h2>
      <DataTable
        columns={columns}
        data={journals}
        noHeader
        pagination
        responsive
        highlightOnHover
        pointerOnHover
        striped
        dense
        noDataComponent={<div style={{ padding: '16px', textAlign: 'center', color: '#777', width: '100%' }}>
          <hr />
          <label style={{ color: '#777', fontWeight: 'bold', fontSize: '1.1rem' }}>ไม่พบข้อมูล</label>
        </div>}
      />

      {popupOpen && selectedJournal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 999,
          }}
          onClick={closeActionPopup}
        >
          <div
            style={{
              backgroundColor: '#fff',
              padding: '20px',
              borderRadius: '8px',
              width: 'min(95vw, 500px)',
              boxShadow: '0 2px 18px rgba(0, 0, 0, 0.25)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3>อนุมัติรายการ สินค้า</h3>
            <p><strong>TDScode:</strong> {selectedJournal.tdscode || '-'}</p>
            <p><strong>Revision:</strong> {selectedJournal.revision || '-'}</p>
            <p><strong>ประเภทงาน:</strong> {selectedJournal.fname || '-'}</p>
            <p><strong>ประเภทงาน:</strong> {selectedJournal.itemcode || '-'}</p>
            <p><strong>ชื่อผลิตภัณฑ์:</strong> {selectedJournal.productname || '-'}</p>
            <p><strong>ผู้สร้าง:</strong> {selectedJournal.createbyName || '-'}</p>

            <div style={{ margin: '12px 0', display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <label
                  htmlFor="passArrange"
                  style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontWeight: '600', color: '#333' }}
                >
                  <input
                    id="passArrange"
                    name="qcStatus"
                    type="radio"
                    checked={checkedPass}
                    onChange={() => { setCheckedPass(true); setCheckedFail(false); }}
                    style={{ width: '18px', height: '18px', accentColor: '#28a745' }}
                  />
                  ผ่านตรวจสอบ
                </label>

                <label
                  htmlFor="failArrange"
                  style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontWeight: '600', color: '#333' }}
                >
                  <input
                    id="failArrange"
                    name="qcStatus"
                    type="radio"
                    checked={checkedFail}
                    onChange={() => { setCheckedFail(true); setCheckedPass(false); }}
                    style={{ width: '18px', height: '18px', accentColor: '#dc3545' }}
                  />
                  ไม่ผ่านตรวจสอบ
                </label>

                <span style={{ color: checkedPass ? '#28a745' : checkedFail ? '#dc3545' : '#777', fontSize: '0.95rem' }}>
                  {checkedPass ? 'สถานะ: ผ่านจัดเรียบร้อย' : checkedFail ? 'สถานะ: ไม่ผ่าน' : 'สถานะ: ยังไม่ได้เลือก'}
                </span>
              </div>

              

              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <label style={{ fontWeight: 600 }}>หมายเหตุ (Remark):</label>
                <textarea
                  value={remarkText}
                  onChange={(e) => setRemarkText(e.target.value)}
                  placeholder="ระบุหมายเหตุเพิ่มเติม"
                  rows={3}
                  style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ccc', resize: 'vertical' }}
                />
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
              <button
                type="button"
                onClick={() => {
                  updateJournalStatus(selectedJournal);
                  // custom action ตัวอย่าง
                  // alert(`ยืนยันรายการ ${selectedJournal.tdscode || '-'} เสร็จแล้ว`);
                  closeActionPopup();
                }}
                style={{ padding: '8px 12px', borderRadius: '4px', border: '1px solid #28a745', background: '#28a745', color: '#fff', cursor: 'pointer' }}
              >
                ยืนยัน
              </button>
              <button
                type="button"
                onClick={closeActionPopup}
                style={{ padding: '8px 12px', borderRadius: '4px', border: '1px solid #ccc', background: '#fff', color: '#333', cursor: 'pointer' }}
              >
                ปิด
              </button>
            </div>
          </div>
        </div>

      )}
    </div>
  );
};

export default Quaritylistjournal
